import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SideDrawer } from "@dmc/ui";
import useValidationPhone from "../../hooks/useValidationPhone";
import ModalLoader from "./ModalLoader";
import { ApiINNCompany } from "../../api/ApiINNCompany";
import ApiData from "../../api/ApiData";
import { observer } from "mobx-react-lite";
import { ButtonFunctional } from "../UI/ButtonFunctional";
import { InputEditVer1 } from "../UI/InputEditVer1";
import Msg from "../../api/Msg";
import { useValidationNumber } from "../../hooks/useValidationNumber";
import RegionComponent from "./RegionComponent";
import stateRegion from "../../state/state.region";
import { ManagerPicker } from "./ManagerPicker";
import { CcV4Toggle } from "../UI/CcV4Toggle";

const NewCompany = observer(
  ({
    ClosedContainerNewCard,
    onClickCancel,
    defaultIsPartner = false,
    partnerToggleReadOnly = false,
  }) => {
  //   Переменные компании
  const [nameCompany, setNameCompany] = useState("");
  const [kpp, setKpp] = useState("");
  const validKpp = useValidationNumber(kpp);
  const [inn, setInn] = useState("");
  const validInn = useValidationNumber(inn);
  const [companyAddress, setCompanyAddress] = useState("");
  const [phone, setPhone] = useState("");
  const validPhone = useValidationPhone(phone);
  const [contactRepresentative, setContactRepresentative] = useState("");
  const [descriptions, setDescriptions] = useState("");

  const [loadingCompanyINN, setLoadingCompanyINN] = useState(false);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedSupportManager, setSelectedSupportManager] = useState(null);
  const [isPartner, setIsPartner] = useState(defaultIsPartner);
  const [managerPickerOpen, setManagerPickerOpen] = useState(false);
  const [supportManagerPickerOpen, setSupportManagerPickerOpen] =
    useState(false);

  const formatManagerLabel = (manager) => {
    if (!manager) {
      return "менеджер не выбран";
    }
    const name = [manager.first_name, manager.last_name, manager.father_name]
      .filter(Boolean)
      .join(" ");
    return name || "менеджер не выбран";
  };

  const dt = {
    inn: String(inn).replace(/\D/gm, ""),
    name_company: nameCompany,
    address_company: companyAddress,
    phone: String(phone).replace(/\D/gm, ""),
    contact_representative: contactRepresentative,
    number_company: 1,
  };

  const setCompany = () => {
    if (
      nameCompany === "" ||
      (kpp === "" &&
        inn.replace(/\D/gm, "").length === 10 &&
        stateRegion.region === "RU") ||
      inn === "" ||
      companyAddress === "" ||
      contactRepresentative === "" ||
      phone === ""
    ) {
      return Msg.writeMessages("Не все поля заполнены");
    }
    ApiData.setParametersCompany("clients_soft", null, true);
    ApiData.setParametersCompany("licensing", null, true);
    ApiData.setParametersCompany("licensing_info", null, true);
    ApiData.setParametersCompany("licensing_free", null, true);
    ApiData.setParametersCompany("company_mark_category", null, true);
    ApiData.setParametersCompany("productions", null, true);
    if (stateRegion.region === "RU") {
      if (kpp.length !== 9 && inn.length === 10) {
        return Msg.writeMessages("КПП должно быть 9 цифр");
      }
      if (
        inn.replace(/\D/gm, "").length !== 10 &&
        inn.replace(/\D/gm, "").length !== 12
      ) {
        return Msg.writeMessages("ИНН должно быть 10 или 12 цифр");
      }
      if (
        kpp.replace(/\D/gm, "").length === 9 &&
        inn.replace(/\D/gm, "").length === 10
      ) {
        dt["kpp"] = kpp;
      }
    }
    if (descriptions !== "") {
      dt["descriptions"] = descriptions;
    }
    if (stateRegion.region === "BY") {
      if (inn.replace(/\D/gm, "").length !== 9) {
        return Msg.writeMessages("УНП должно быть 9 цифр");
      }
    }
    const writeCountry = stateRegion.collectionRegion.find(
      (c) => c.tag_country === stateRegion.region
    );
    if (writeCountry) {
      dt["country_id"] = writeCountry.id;
    }
    dt.is_partner = isPartner;
    if (selectedManager?.id) {
      dt.users_id = selectedManager.id;
    }
    if (selectedSupportManager?.id) {
      dt.support_users_id = selectedSupportManager.id;
    }
    ApiData.newCompany(dt);
  };

  const removeField = () => {
    setNameCompany("");
    setKpp("");
    setInn("");
    setCompanyAddress("");
    setPhone("");
    setContactRepresentative("");
    setDescriptions("");
    setSelectedManager(null);
    setSelectedSupportManager(null);
    setIsPartner(false);
    setManagerPickerOpen(false);
    setSupportManagerPickerOpen(false);
  };

  const addNext = () => {
    ApiData.updateFlagCreateCompany(false);
    removeField();
  };

  return (
    <SideDrawer
      open
      onClose={onClickCancel}
      title="Создание новой компании"
      usePortal={false}
      footer={
        !ApiData.create_company_pass ? (
          <>
            <ButtonFunctional onClick={setCompany}>Сохранить</ButtonFunctional>
            <ButtonFunctional onClick={onClickCancel}>Отмена</ButtonFunctional>
          </>
        ) : (
          <>
            <ButtonFunctional onClick={addNext} className="add-new-card">
              Добавить следующую
            </ButtonFunctional>
            <Link to={`/company/${inn}`}>
              <ButtonFunctional className="add-new-card">
                Перейти к текущей
              </ButtonFunctional>
            </Link>
            <ButtonFunctional
              onClick={ClosedContainerNewCard}
              className="add-new-card"
            >
              Закрыть
            </ButtonFunctional>
          </>
        )
      }
    >
      {loadingCompanyINN ? <ModalLoader /> : null}
      <div className="add-item-container">
        <div className="card-flex-container">
          <ul className="col-ul-new-card" style={{ width: "100%" }}>
            <li className="new_company_inn_block">
              <span>
                {stateRegion.region === "RU"
                  ? "ИНН"
                  : stateRegion.region === "BY"
                  ? "УНП"
                  : "БИН"}
              </span>{" "}
              <ApiINNCompany
                inn={validInn}
                setNameCompany={setNameCompany}
                setCompanyAddress={setCompanyAddress}
                setKpp={setKpp}
                setLoadingCompanyINN={setLoadingCompanyINN}
              />
            </li>
            <li>
              <InputEditVer1
                value={String(validInn)}
                onChange={(e) => setInn(e.target.value)}
                placeholder={`Введите ${
                  stateRegion.region === "RU"
                    ? "ИНН"
                    : stateRegion.region === "BY"
                    ? "УНП"
                    : "БИН"
                }`}
                style={{ width: "50%" }}
              />
            </li>

            <li className="mrg-top-12">Наименование</li>
            <li>
              {" "}
              <InputEditVer1
                value={nameCompany}
                onChange={(e) => setNameCompany(e.target.value)}
                placeholder="Введите наименование компании"
                style={{ width: "100%" }}
              />
            </li>

            <li className="mrg-top-12">Адрес</li>
            <li>
              <InputEditVer1
                value={companyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
                placeholder="Введите адрес компании"
                style={{ width: "100%" }}
              />
            </li>

            <li className="mrg-top-12">Контактное лицо</li>
            <li>
              <InputEditVer1
                value={contactRepresentative}
                onChange={(e) => setContactRepresentative(e.target.value)}
                placeholder="Введите имя ответственного сотрудника"
                style={{ width: "100%" }}
              />
            </li>
            {stateRegion.region === "RU" ? (
              <>
                {inn.length <= 10 ? (
                  <>
                    {" "}
                    <li className="mrg-top-12">КПП</li>
                    <li>
                      <InputEditVer1
                        value={validKpp}
                        onChange={(e) => setKpp(e.target.value)}
                        placeholder="Введите КПП компании"
                        style={{ width: "100%" }}
                      />
                    </li>
                  </>
                ) : (
                  null
                )}
              </>
            ) : (
              null
            )}

            <li className="mrg-top-12">Телефон</li>
            <li>
              {" "}
              <InputEditVer1
                value={validPhone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Введите контактный телефон сотрудника"
                style={{ width: "100%" }}
              />
            </li>
            <li className="mrg-top-12">Описание</li>
            <li>
              {" "}
              <textarea
                className="comment"
                placeholder="Введите дополнительное описание или комментарии"
                value={descriptions}
                onChange={(e) => setDescriptions(e.target.value)}
              ></textarea>
            </li>
            <li className="mrg-top-12">
              <div className="company-card-v4 new-company-manager-partner">
                <div className="company-edit-manager-field new-company-manager-wrap">
                  <span className="site-form-label">Ответственный менеджер</span>
                  <div className="company-edit-manager-row">
                    <span
                      className={
                        selectedManager ? "req-value" : "req-value req-value-muted"
                      }
                    >
                      {formatManagerLabel(selectedManager)}
                    </span>
                    <button
                      type="button"
                      className="btn-outline-v4"
                      onClick={() => {
                        setSupportManagerPickerOpen(false);
                        setManagerPickerOpen(true);
                      }}
                    >
                      {selectedManager ? "Изменить" : "Выбрать"}
                    </button>
                  </div>
                  {managerPickerOpen ? (
                    <ManagerPicker
                      onSelect={setSelectedManager}
                      onClose={() => setManagerPickerOpen(false)}
                    />
                  ) : null}
                </div>
                <div className="company-edit-manager-field new-company-manager-wrap">
                  <span className="site-form-label">Менеджер сопровождения</span>
                  <div className="company-edit-manager-row">
                    <span
                      className={
                        selectedSupportManager
                          ? "req-value"
                          : "req-value req-value-muted"
                      }
                    >
                      {formatManagerLabel(selectedSupportManager)}
                    </span>
                    <button
                      type="button"
                      className="btn-outline-v4"
                      onClick={() => {
                        setManagerPickerOpen(false);
                        setSupportManagerPickerOpen(true);
                      }}
                    >
                      {selectedSupportManager ? "Изменить" : "Выбрать"}
                    </button>
                  </div>
                  {supportManagerPickerOpen ? (
                    <ManagerPicker
                      onSelect={setSelectedSupportManager}
                      onClose={() => setSupportManagerPickerOpen(false)}
                    />
                  ) : null}
                </div>
                <div className="company-edit-partner-field">
                  <CcV4Toggle
                    active={isPartner}
                    label="Партнёр"
                    disabled={partnerToggleReadOnly}
                    onClick={() => setIsPartner((v) => !v)}
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
        <RegionComponent />
      </div>
    </SideDrawer>
  );
});

export default NewCompany;
